import { render, staticRenderFns } from "./NoticeList.vue?vue&type=template&id=52c8708e&scoped=true&"
import script from "./NoticeList.vue?vue&type=script&lang=js&"
export * from "./NoticeList.vue?vue&type=script&lang=js&"
import style0 from "./NoticeList.vue?vue&type=style&index=0&id=52c8708e&prod&lang=scss&scoped=true&"
import style1 from "./NoticeList.vue?vue&type=style&index=1&id=52c8708e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c8708e",
  null
  
)

export default component.exports